module.exports = __webpack_public_path__ + "img/sign-banner-m.afdf40aa.jpg";